import type { Editor } from '@tiptap/react';

export const getSelectionAsText = (editor: Editor) => {
  const {
    state: {
      doc,
      selection: { from, to, $from, $to },
    },
  } = editor;

  const fragment = $from.sameParent($to)
    ? $from.parent.cut($from.parentOffset, $to.parentOffset)
    : doc.cut(from, to);

  return fragment.textContent;
};
